<template>
    <v-container>
        <ws-page
        v-bind="arts"
        />
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in workshopsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < workshopsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </v-container>
</template>

<script>
  import WsPage from '../../components/base/WsPage.vue'
  export default {
  components: { WsPage },
    name: 'EArts',

    data: () => ({
      isMobile: false,
      workshopsfooter: [
        {
          name: 'Fringe Workshops',
          url: 'fringe-workshops',
        },
        {
          name: 'AI-Treats',
          url: 'ai-treats',
        },
        {
          name: 'eARTS',
          url: 'e-arts',
        },
        {
          name: 'IMTR',
          url: 'imtr',
        },
      ],
      arts: {
        title: 'European Automotive Reliability, Test & Safety Workshop (eARTS)',
        website: 'https://cas.polito.it/eARTS2023/',
        abstract: 'Automotive electronics is becoming more and more relevant in the daily life, especially with the advent of the autonomous driving. People will become 100% dependent on the proper operation of the electronic systems. The 3rd European Automotive Reliability, Test and Safety workshop (eARTS) intends to focus on test, reliability, and safety of automotive electronics, including IC design, test development, system-level integration, production testing, in-field test, diagnosis and repair solutions, cybersecurity, as well as architectures and methods for reliable, safe, and secure operation in the field. The eARTS Workshop wants to offer a forum for industry specialists and academic researchers to present and discuss these challenges and emerging solutions. The workshop’s areas of interest include (but are not limited to) the following topics: Automotive Design-for-Test: enable high quality at low cost, Statistical post-processing, Machine Learning, and AI for test and reliability, Latent defect activation during production testing, Built-In Self-Test in automotive systems: digital, analog, mixed-signal, Reuse of test infrastructure and New Product Development acceleration, Dependability challenges of autonomous driving and e-mobility, Functional safety and cyber-security, Automotive standards and certification - ISO 26262, AEC-Q100, Approximate computing for automotive, Verification and validation of automotive systems, Fault tolerance and self-checking circuits, Aging effects on automotive electronics, Power-up, power-down and periodic test, System level test, Functional and structural test generation, Automotive production testing',
        chairs: '<strong>General Chairs:</strong> Yervant Zorian (Synopsys, US) and Davide Appello (STMicroelectronics, IT) <br> <strong>Program Chair:</strong> Riccardo Cantoro (Politecnico di Torino, IT) and Wim Dobbeleare (onsemi, BE)',
        dates: [
          {
          name: 'Workshop Papers submission deadline',
          date: '<s>1 March 2023</s> <strong>20 March 2023</strong> <span style="color: red;">(Extended Deadline)</span>',
          },
          {
            name: 'Authors notification',
            date: '1 April 2023',
          },
        ],
        image: require('@/assets/earts.png'),
      },
    }),
    mounted() {

    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
